import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { getTeamDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import { token } from "../../../../components/constant/constant";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";
import Select from "react-select";

const Editteam = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [profile_pic_name, setProfile_pic_name] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const id = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const teamView = useSelector((state) => state.teamView);
  const { team } = teamView;
  const [countryId, setCountryID] = useState([]);
  const [data, setData] = useState([]);

  let token = localStorage.getItem("accessToken");

  useEffect(() => {
    dispatch(getTeamDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (team?.data?.profile_pic !== null) {
      setFile({
        files: team?.data?.profile_pic,
        preview: team?.data?.profile_pic,
      });
    } else {
      setFile({
        files: "",
        preview:
          "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
      });
    }
  }, [team]);

  useEffect(() => {
    if (teamView) {
      if (teamView?.loading !== undefined) {
        setLoading(teamView?.loading);
      }
    }
  }, [teamView]);

  useEffect(() => {}, [file]);

  useEffect(() => {
    if (team) {
      setValue("firstname", team?.data?.firstname);
      setValue("lastname", team?.data?.lastname);
      setValue("order_no", team?.data?.order_no);
      setValue("en_profile", team?.data?.en_profile);
      setValue("it_profile", team?.data?.it_profile);
      setValue("fr_profile", team?.data?.fr_profile);
      setValue("es_profile", team?.data?.es_profile);
      setValue("pl_profile", team?.data?.pl_profile);
      setValue("profile_designation", team?.data?.profile_designation);
      setValue("facebook_handle", team?.data?.facebook_handle);
      setValue("gmail_handle", team?.data?.gmail_handle);
      setValue("linkdin_handle", team?.data?.linkdin_handle);
      setValue("education", team?.data?.education);
      setValue("role", team?.data?.role);
      setProfile_pic_name(team?.data?.profile_pic);
      setCountryID(team?.data?.country_id);
    }
  }, [team]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = async (e) => {
    const baseUrl =
      process.env.REACT_APP_API + "admin/update-our-team-profilepic";
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let formData = new FormData();
      setLoading(true);
      formData.append("id", id.teamId);
      formData.append("file", selected);
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      };
      const res = await axios
        .patch(baseUrl, formData, axiosConfig)
        .then((response) => {
          setFile({
            files: response?.data?.data?.profile_pic,
            preview: response?.data?.data?.profile_pic,
          });
          setLoading(false);
          setError(false);
        });
    } else {
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountry();
  }, []);

  const getCountry = async () => {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API + "get-country",
    });

    const data = res?.data?.data;
    const options = data?.map((d) => ({
      value: d?.id,
      label: d?.country_name,
    }));
    setData(options);
  };

  const handleCountry = (e) => {
    setCountryID(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();

    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("country_id", JSON.stringify(countryId));
    formData.append("id", id.teamId);
    // if (file.files !== "" && team?.data?.profile_pic == "") {
    //   formData.append("file", file?.files);
    // } else if (file.files !== "" && team?.data?.profile_pic !== "") {
    //   formData.append("file", file?.files);
    //   formData.append("profile_pic_name", team?.data?.profile_pic);
    // }
    formData.append("file", file?.files);

    // formData.append("profile_pic_name", profile_pic_name);
    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "admin/update-our-team",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/our-teams");
      }
    } catch (error) {
      if (error.response !== "" && error.response.data.message !== "") {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit New Team</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : team?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  {...register("firstname", {
                    required: "First name is required",
                    pattern: {
                      value: /^[a-zA-Z._ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter First Name"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">
                    {errors.firstname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  {...register("lastname", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastname && (
                  <div className="invalid-feedback">
                    {errors.lastname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Designation</label>
                <input
                  type="text"
                  name="profile_designation"
                  {...register("profile_designation", {
                    required: "Designation is required",
                    // pattern: {
                    //   value: /^[a-zA-Z_ ]*$/,
                    //   message: "Please enter only characters",
                    // },
                  })}
                  placeholder="Enter Designation"
                />
                {errors.profile_designation && (
                  <div className="invalid-feedback">
                    {errors.profile_designation.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Country</label>

                <Select
                  className="sort-by dropdown"
                  isMulti={true}
                  options={data}
                  value={countryId?.map(
                    (id) => data?.filter((d) => d.value == id)[0]
                  )}
                  onChange={handleCountry}
                />
              </div>
              <div className="formInput">
                <label>Email Link</label>
                <input
                  type="text"
                  name="gmail_handle"
                  {...register("gmail_handle")}
                  placeholder="Enter Email"
                />
                {errors.gmail_handle && (
                  <div className="invalid-feedback">
                    {errors.gmail_handle.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Role</label>
                <select name="role" {...register("role")}>
                  <option value="" disabled selected hidden>
                    Select
                  </option>
                  <option value="Executive Leaders">Executive Leaders</option>
                  <option value="Board Members">Board members</option>
                  <option value="Management">Management</option>
                  <option value="Consultant">Consultants</option>
                </select>
              </div>

              <div className="formInput">
                <label>Facebook Link</label>
                <input
                  type="text"
                  name="facebook_handle"
                  {...register("facebook_handle")}
                  placeholder="Enter Facebook"
                />
                {errors.facebook_handle && (
                  <div className="invalid-feedback">
                    {errors.facebook_handle.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Linkedin Link</label>
                <input
                  type="text"
                  name="linkdin_handle"
                  {...register("linkdin_handle")}
                  placeholder="Enter Linkedin"
                />
                {errors.linkdin_handle && (
                  <div className="invalid-feedback">
                    {errors.linkdin_handle.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Education</label>
                <input
                  type="text"
                  name="education"
                  {...register("education")}
                  placeholder="Enter Education"
                />
                {errors.education && (
                  <div className="invalid-feedback">
                    {errors.education.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Display Order</label>
                <input
                  type="number"
                  name="order_no"
                  {...register("order_no", {
                    required: "Order No is required",
                    min: 0,
                    // pattern: /^[0-9]+$/,
                  })}
                  placeholder="Enter Order No"
                />
                {errors.order_no && (
                  <div className="invalid-feedback">
                    {errors.order_no.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>English Description</label>

                <textarea
                  type="text"
                  name="en_profile"
                  {...register("en_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  className="description-textarea"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.en_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.en_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Italian Description</label>

                <textarea
                  type="text"
                  name="it_profile"
                  {...register("it_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  className="description-textarea"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.it_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.it_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>French Description</label>

                <textarea
                  type="text"
                  name="fr_profile"
                  {...register("fr_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  className="description-textarea"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.fr_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.fr_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Spanish Description</label>

                <textarea
                  type="text"
                  name="es_profile"
                  {...register("es_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  className="description-textarea"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.es_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.es_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Polish Description</label>

                <textarea
                  type="text"
                  name="pl_profile"
                  {...register("pl_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  className="description-textarea"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.pl_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.pl_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput"></div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editteam;
